import { render, staticRenderFns } from "./DashboardBusinessJobs.vue?vue&type=template&id=2921bc80"
import script from "./DashboardBusinessJobs.vue?vue&type=script&lang=js"
export * from "./DashboardBusinessJobs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {JobRow: require('/opt/atlassian/pipelines/agent/build/components/job/JobRow.vue').default,JobQuotesBusinessRow: require('/opt/atlassian/pipelines/agent/build/components/job/JobQuotesBusinessRow.vue').default,FormSiteButton: require('/opt/atlassian/pipelines/agent/build/components/form/SiteButton.vue').default,SiteEmpty: require('/opt/atlassian/pipelines/agent/build/components/SiteEmpty.vue').default})
